/**
 * Single authoritative session-id resolution rule (F4).
 *
 * The REST GameState's `session_id` is authoritative. A direct /game/:id deep
 * link may boot with a seed of 0 (no nav state, nothing in sessionStorage);
 * once the authoritative value arrives it must win everywhere that needs the
 * session id (chat, leave decision, round-end SessionChannel, next-round).
 *
 *   authoritative present (> 0) → use it (heals a 0 seed, corrects a conflict)
 *   otherwise                   → keep the seed (0 means "still unknown")
 *
 * Pure so both the React shell (GameScreen) and the Phaser scene (GameScene)
 * resolve it identically without cross-talk.
 */
export function resolveSessionId(seed: number, restSessionId: number | null | undefined): number {
  if (typeof restSessionId === 'number' && restSessionId > 0) return restSessionId;
  return seed > 0 ? seed : 0;
}
